<template>
  <section v-if="version === 'v1'" style="background-color: var(--tertiary_color); z-index: 50">
    <div
      class="tw-flex tw-grid tw-grid-cols-12 tw-items-center tw-gap-y-3 lg:tw-rounded-r-md xl:tw-border xl:tw-border-[#CCCCCC]"
    >
      <div class="locations-box-container tw-col-span-12 md:tw-col-span-12 lg:tw-col-span-6 xl:tw-col-span-4">
        <div class="properties-filter-item tw-flex tw-flex-row tw-items-center">
          <locations v-model="searchInputModel" v-model:locations="locationsModel" />
        </div>
      </div>
      <div class="price-inputs-container tw-col-span-12 tw-h-full md:tw-col-span-12 lg:tw-col-span-6 xl:tw-col-span-3">
        <lazy-library-properties-search-box-price-input v-model:filters="filtersModel" :search-type="searchType" />
      </div>
      <div class="nc-text bedroom-inputs-container tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-6 xl:tw-col-span-2">
        <div class="w-100 h-100 form-field-wrapper d-flex flex-row justify-content-center align-items-center">
          <multiple-input-group popup-width="300px">
            <template #front-item>
              <div class="w-100 d-flex flex-row align-items-center justify-content-center properties-filter-item">
                {{ minBedroomLabel }}<span class="px-2">-</span>{{ maxBedroomLabel }}
                Beds
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 10L12 15L17 10H7Z" fill="#AF624E" />
                </svg>
              </div>
            </template>
            <template #group>
              <div class="d-flex flex-row row g-0 tw-py-2">
                <select v-model="filtersModel.min_bedroom" class="col-5" style="border: unset !important">
                  <option
                    v-for="(bedroomCount, index) in minBedroomCounts"
                    :key="`bedroomCountForMin-${index}`"
                    :value="bedroomCount.value"
                  >
                    {{ bedroomCount.name }}
                  </option>
                </select>
                <div class="col-2 text-center">-</div>
                <select v-model="filtersModel.max_bedroom" class="col-5" style="border: unset !important">
                  <option
                    v-for="(bedroomCount, index) in maxBedroomCounts"
                    :key="`bedroomCountForMax-${index}`"
                    :value="bedroomCount.value"
                  >
                    {{ bedroomCount.name }}
                  </option>
                </select>
              </div>
            </template>
          </multiple-input-group>
        </div>
      </div>
      <div class="tw-col-span-12 tw-grid tw-grid-cols-12 tw-gap-y-3 md:tw-col-span-6 xl:tw-col-span-3">
        <div class="nc-text filters-box-container tw-col-span-12 md:tw-col-span-6" @click="openExtendedPopup()">
          <div
            class="d-flex flex-row px-3 justify-content-center justify-content-lg-around align-items-center n-cursor-pointer properties-filter-item"
          >
            <div>
              Filters
              <span v-if="advancedFilterSelectionCount > 0">({{ advancedFilterSelectionCount }})</span>
            </div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10L12 15L17 10H7Z" fill="#AF624E" />
            </svg>
          </div>
        </div>
        <div class="tw-col-span-12 md:tw-col-span-6">
          <nc-button label="SEARCH" :height="57" @on-click="onSearch()">
            <template #label>
              <div class="tw-flex tw-flex-row tw-items-center tw-gap-x-2">
                <span class="tw-uppercase">Search</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.4995 15.8333L13.2045 11.5383C13.9985 10.3316 14.3165 8.87314 14.097 7.44537C13.8774 6.01761 13.1359 4.72208 12.016 3.80963C10.8961 2.89718 9.47752 2.43271 8.03484 2.50614C6.59216 2.57958 5.22805 3.1857 4.2066 4.20715C3.18515 5.22859 2.57903 6.59271 2.50559 8.03539C2.43216 9.47807 2.89663 10.8967 3.80908 12.0166C4.72154 13.1365 6.01706 13.878 7.44483 14.0975C8.87259 14.317 10.331 13.999 11.5378 13.205L15.8328 17.5L17.4995 15.8333ZM4.16612 8.33333C4.16612 6.03584 6.03529 4.16667 8.33279 4.16667C10.6303 4.16667 12.4995 6.03584 12.4995 8.33333C12.4995 10.6308 10.6303 12.5 8.33279 12.5C6.03529 12.5 4.16612 10.6308 4.16612 8.33333Z"
                    class="nc-button-icon"
                  />
                </svg>
              </div>
            </template>
          </nc-button>
        </div>
      </div>
    </div>
  </section>

  <div
    v-else-if="version === 'v2'"
    class="properties-search-box tw-flex tw-flex-col tw-gap-6 tw-bg-white tw-px-6 tw-py-8"
    style="border-radius: var(--rounded-input)"
  >
    <h4 class="search-title">{{ title ? title : 'Search' }}</h4>
    <div
      v-if="buy && rent && alternativeLayout"
      class="n-searchbox tw-col-span-3 tw-flex tw-w-full tw-gap-2 tw-border tw-p-[2px] xl:tw-col-span-1"
      style="border-radius: var(--rounded); min-width: 140px"
    >
      <button
        class="tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-whitespace-nowrap"
        :class="{
          'n-secondary': searchType === PFilterSearchType.SALES,
          'n-secondary outlined': searchType === PFilterSearchType.LETTINGS,
        }"
        @click="onSearchTypeChanged(PFilterSearchType.SALES)"
      >
        BUY
      </button>
      <button
        class="tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-whitespace-nowrap"
        :class="{
          'n-tertiary': searchType === PFilterSearchType.LETTINGS,
          'n-tertiary outlined': searchType === PFilterSearchType.SALES,
        }"
        @click="onSearchTypeChanged(PFilterSearchType.LETTINGS)"
      >
        RENT
      </button>
    </div>
    <div v-if="buy && rent && !alternativeLayout" class="n-searchbox tw-flex tw-w-full tw-gap-4">
      <!-- buy -->
      <button
        class="select-button"
        :class="{ active: searchType === PFilterSearchType.SALES }"
        @click="onSearchTypeChanged(PFilterSearchType.SALES)"
      >
        BUY
      </button>
      <!-- rent -->
      <button
        class="select-button"
        :class="{ active: searchType === PFilterSearchType.LETTINGS }"
        @click="onSearchTypeChanged(PFilterSearchType.LETTINGS)"
      >
        RENT
      </button>
    </div>
    <!-- search -->
    <div class="searchbox-location-selectbox">
      <locations version="v2" v-model="searchInputModel" v-model:locations="locationsModel" />
    </div>
    <library-properties-search-box-price-input v-model:filters="filtersModel" :search-type="searchType" version="v2" />

    <div class="bedroom-filter tw-flex tw-items-center tw-gap-4">
      <multiple-input-group popup-width="300px" class="tw-w-full tw-min-w-[173px]">
        <template #front-item>
          <div
            class="multiple-input-group tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-border tw-bg-white tw-py-3 tw-pl-4 tw-pr-5"
            style="border-radius: var(--rounded-input); border-color: var(--c-border)"
          >
            <div class="tw-text-nowrap">{{ minMaxBedroomLabel }}</div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10L12 15L17 10H7Z" fill="var(--c-icon)" />
            </svg>
          </div>
        </template>
        <template #group>
          <div class="tw-flex tw-gap-4 tw-px-2">
            <select v-model="filtersModel.min_bedroom">
              <option
                v-for="(bedroomCount, index) in minBedroomCounts"
                :key="`bedroomCountForMin-${index}`"
                :value="bedroomCount.value"
              >
                {{ bedroomCount.name }}
              </option>
            </select>

            <select v-model="filtersModel.max_bedroom">
              <option
                v-for="(bedroomCount, index) in maxBedroomCounts"
                :key="`bedroomCountForMax-${index}`"
                :value="bedroomCount.value"
              >
                {{ bedroomCount.name }}
              </option>
            </select>
          </div>
        </template>
      </multiple-input-group>

      <!-- filter -->
      <button
        @click="openExtendedPopup()"
        class="property-filter-btn n-quaternary tw-flex tw-w-full tw-items-center tw-justify-between"
      >
        <div>
          Filter
          <span v-if="advancedFilterSelectionCount > 0">({{ advancedFilterSelectionCount }})</span>
        </div>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 7.5H7C6.60218 7.5 6.22064 7.65804 5.93934 7.93934C5.65804 8.22064 5.5 8.60218 5.5 9V17C5.5 17.3978 5.65804 17.7794 5.93934 18.0607C6.22064 18.342 6.60218 18.5 7 18.5H15C15.3978 18.5 15.7794 18.342 16.0607 18.0607C16.342 17.7794 16.5 17.3978 16.5 17V12"
            stroke="var(--c-icon)"
            stroke-width="1.2"
            stroke-linecap="round"
          />
          <path
            d="M12.5 11.5L18.864 5.136M14.5 4.5H19.5V9.5"
            stroke="var(--c-icon)"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
    <button @click="onSearch()" class="n-primary search-button tw-h-full tw-w-full">
      <template v-if="!iconOnly">Search</template>
      <template v-if="iconOnly">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          :class="{ 'tw-ml-2': !iconOnly }"
        >
          <path
            d="M17.4995 15.8333L13.2045 11.5383C13.9985 10.3316 14.3165 8.87314 14.097 7.44537C13.8774 6.01761 13.1359 4.72208 12.016 3.80963C10.8961 2.89718 9.47752 2.43271 8.03484 2.50614C6.59216 2.57958 5.22805 3.1857 4.2066 4.20715C3.18515 5.22859 2.57903 6.59271 2.50559 8.03539C2.43216 9.47807 2.89663 10.8967 3.80908 12.0166C4.72154 13.1365 6.01706 13.878 7.44483 14.0975C8.87259 14.317 10.331 13.999 11.5378 13.205L15.8328 17.5L17.4995 15.8333ZM4.16612 8.33333C4.16612 6.03584 6.03529 4.16667 8.33279 4.16667C10.6303 4.16667 12.4995 6.03584 12.4995 8.33333C12.4995 10.6308 10.6303 12.5 8.33279 12.5C6.03529 12.5 4.16612 10.6308 4.16612 8.33333Z"
            fill="white"
          />
        </svg>
      </template>
    </button>
  </div>

  <div v-else-if="version === 'v3'" class="properties-search-box tw-grid tw-grid-cols-[45.83%,21.83%,32.33%]">
    <div class="">
      <locations v-model="searchInputModel" v-model:locations="locationsModel" version="v2" />
    </div>
    <div class="tw-h-full">
      <library-properties-search-box-price-input
        v-model:filters="filtersModel"
        :search-type="searchType"
        version="v2"
      />
    </div>

    <div class="">
      <div class="tw-flex tw-h-full tw-items-center">
        <multiple-input-group popup-width="300px" class="tw-h-full tw-w-full tw-min-w-[173px]">
          <template #front-item>
            <div
              class="searchbox-bedroom tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-bg-white tw-py-5 tw-pl-4 tw-pr-5"
              style=""
            >
              <div class="tw-text-nowrap">{{ minMaxBedroomLabel }}</div>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 10L12 15L17 10H7Z" fill="#000" />
              </svg>
            </div>
          </template>
          <template #group>
            <div class="tw-flex tw-h-full tw-items-center tw-justify-center tw-gap-4 tw-px-2">
              <select v-model="filtersModel.min_bedroom">
                <option
                  v-for="(bedroomCount, index) in minBedroomCounts"
                  :key="`bedroomCountForMin-${index}`"
                  :value="bedroomCount.value"
                >
                  {{ bedroomCount.name }}
                </option>
              </select>

              <select v-model="filtersModel.max_bedroom">
                <option
                  v-for="(bedroomCount, index) in maxBedroomCounts"
                  :key="`bedroomCountForMax-${index}`"
                  :value="bedroomCount.value"
                >
                  {{ bedroomCount.name }}
                </option>
              </select>
            </div>
          </template>
        </multiple-input-group>

        <!-- filter -->
        <button
          @click="openExtendedPopup()"
          class="properties-filter tw-flex tw-w-full tw-items-center tw-justify-between"
        >
          <div>
            Filter
            <span v-if="advancedFilterSelectionCount > 0">({{ advancedFilterSelectionCount }})</span>
          </div>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 10L12 15L17 10H7Z" fill="#000" />
          </svg>
        </button>

        <!-- search -->
        <button @click="onSearch()" class="properties-searchbox-button n-primary tw-h-full tw-w-full">Search</button>
      </div>
    </div>
  </div>

  <template v-else-if="version === 'v4'">
    <h4 v-if="title" class="tw-pb-8">{{ title }}</h4>

    <div
      class="properties-search-box tw-grid tw-w-full tw-grid-cols-1 tw-justify-between tw-gap-1 max-2xl:tw-gap-6 2xl:tw-grid-cols-[13%,75%,10%]"
      :class="{ '2xl:!tw-grid-cols-[87%,12%]': !(buy && rent) }"
    >
      <div
        v-if="buy && rent && alternativeLayout"
        class="n-searchbox tw-col-span-3 tw-flex tw-w-full tw-gap-2 tw-border tw-p-[2px] xl:tw-col-span-1"
        style="border-radius: var(--rounded); min-width: 140px"
      >
        <button
          class="tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-whitespace-nowrap"
          :class="{
            'n-secondary': searchType === PFilterSearchType.SALES,
            'n-secondary outlined': searchType === PFilterSearchType.LETTINGS,
          }"
          @click="onSearchTypeChanged(PFilterSearchType.SALES)"
        >
          BUY
        </button>
        <button
          class="tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-whitespace-nowrap"
          :class="{
            'n-tertiary': searchType === PFilterSearchType.LETTINGS,
            'n-tertiary outlined': searchType === PFilterSearchType.SALES,
          }"
          @click="onSearchTypeChanged(PFilterSearchType.LETTINGS)"
        >
          RENT
        </button>
      </div>

      <div
        v-if="buy && rent && !alternativeLayout"
        class="n-searchbox tw-col-span-3 tw-flex tw-w-full tw-gap-2 tw-border tw-p-[2px] xl:tw-col-span-1"
        style="border-radius: var(--rounded); min-width: 140px"
      >
        <button
          class="select-button tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-whitespace-nowrap"
          :class="{ active: searchType === PFilterSearchType.SALES }"
          @click="onSearchTypeChanged(PFilterSearchType.SALES)"
        >
          BUY
        </button>
        <button
          class="select-button tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-whitespace-nowrap"
          :class="{ active: searchType === PFilterSearchType.LETTINGS }"
          @click="onSearchTypeChanged(PFilterSearchType.LETTINGS)"
        >
          RENT
        </button>
      </div>

      <div
        class="searchbox-container tw-flex tw-gap-2 tw-border"
        style="border-color: var(--c-border); border-radius: var(--rounded)"
      >
        <div class="searchbox-location-selectbox tw-w-full">
          <locations v-model="searchInputModel" v-model:locations="locationsModel" version="v2" />
        </div>
        <div style="width: 100%; max-width: 340px" class="properties-searchbox-price-input tw-border-r">
          <library-properties-search-box-price-input
            v-model:filters="filtersModel"
            :search-type="searchType"
            version="v2"
          />
        </div>
        <multiple-input-group
          popup-width="300px"
          class="tw-h-full tw-w-full tw-max-w-[173px] tw-border-r"
          style="border-color: var(--c-border)"
        >
          <template #front-item>
            <div
              class="searchbox-bedroom tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-py-5 tw-pl-4 tw-pr-5"
            >
              <div class="tw-text-nowrap">{{ minMaxBedroomLabel }}</div>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 10L12 15L17 10H7Z" fill="var(--c-icon)" />
              </svg>
            </div>
          </template>
          <template #group>
            <div class="tw-flex tw-h-full tw-items-center tw-justify-center tw-gap-4 tw-px-2">
              <select v-model="filtersModel.min_bedroom">
                <option
                  v-for="(bedroomCount, index) in minBedroomCounts"
                  :key="`bedroomCountForMin-${index}`"
                  :value="bedroomCount.value"
                >
                  {{ bedroomCount.name }}
                </option>
              </select>
              <select v-model="filtersModel.max_bedroom">
                <option
                  v-for="(bedroomCount, index) in maxBedroomCounts"
                  :key="`bedroomCountForMax-${index}`"
                  :value="bedroomCount.value"
                >
                  {{ bedroomCount.name }}
                </option>
              </select>
            </div>
          </template>
        </multiple-input-group>
        <button
          @click="openExtendedPopup()"
          class="properties-filter tw-flex tw-w-full tw-max-w-[150px] tw-items-center tw-justify-between"
        >
          <div>
            Filter
            <span v-if="advancedFilterSelectionCount > 0">({{ advancedFilterSelectionCount }})</span>
          </div>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 10L12 15L17 10H7Z" fill="var(--c-icon)" />
          </svg>
        </button>
      </div>

      <div class="search-btn-icon tw-flex tw-h-full tw-items-center">
        <button @click="onSearch()" class="properties-searchbox-button n-primary tw-h-full tw-w-full">
          <template v-if="!iconOnly">Search</template>
          <template v-if="iconOnly">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              :class="{ 'tw-ml-2': !iconOnly }"
            >
              <path
                d="M17.4995 15.8333L13.2045 11.5383C13.9985 10.3316 14.3165 8.87314 14.097 7.44537C13.8774 6.01761 13.1359 4.72208 12.016 3.80963C10.8961 2.89718 9.47752 2.43271 8.03484 2.50614C6.59216 2.57958 5.22805 3.1857 4.2066 4.20715C3.18515 5.22859 2.57903 6.59271 2.50559 8.03539C2.43216 9.47807 2.89663 10.8967 3.80908 12.0166C4.72154 13.1365 6.01706 13.878 7.44483 14.0975C8.87259 14.317 10.331 13.999 11.5378 13.205L15.8328 17.5L17.4995 15.8333ZM4.16612 8.33333C4.16612 6.03584 6.03529 4.16667 8.33279 4.16667C10.6303 4.16667 12.4995 6.03584 12.4995 8.33333C12.4995 10.6308 10.6303 12.5 8.33279 12.5C6.03529 12.5 4.16612 10.6308 4.16612 8.33333Z"
                fill="white"
              />
            </svg>
          </template>
        </button>
      </div>
    </div>
  </template>

  <template v-else-if="version === 'v5'">
    <h4 v-if="title" class="tw-pb-8">{{ title }}</h4>
    <div class="properties-search-box tw-flex tw-w-full tw-items-stretch">
      <div
        v-if="buy && rent"
        class="n-searchbox tw-col-span-3 tw-flex tw-gap-4 tw-border-r tw-p-[2px]"
        style="border-color: var(--c-input_placeholder)"
      >
        <button
          class="select-button"
          :class="{ active: searchType === PFilterSearchType.SALES }"
          @click="onSearchTypeChanged(PFilterSearchType.SALES)"
        >
          BUY
        </button>
        <button
          class="select-button"
          :class="{ active: searchType === PFilterSearchType.LETTINGS }"
          @click="onSearchTypeChanged(PFilterSearchType.LETTINGS)"
        >
          RENT
        </button>
      </div>

      <div
        class="tw-flex tw-flex-grow tw-gap-2 tw-border-r"
        style="border-radius: var(--rounded); background-color: var(--c-input)"
      >
        <locations v-model="searchInputModel" v-model:locations="locationsModel" version="v2" />
        <div style="width: 60%; max-width: 200px; border-color: var(--c-input_placeholder)" class="tw-border-r">
          <library-properties-search-box-price-input
            v-model:filters="filtersModel"
            :search-type="searchType"
            version="v2"
          />
        </div>
        <multiple-input-group
          popup-width="300px"
          class="tw-h-full tw-w-full tw-max-w-[173px] tw-border-r"
          style="border-color: var(--c-input_placeholder)"
        >
          <template #front-item>
            <div
              class="searchbox-bedroom tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-py-5 tw-pl-4 tw-pr-5"
            >
              <div class="tw-text-nowrap">{{ minMaxBedroomLabel }}</div>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 10L12 15L17 10H7Z" fill="var(--c-icon)" />
              </svg>
            </div>
          </template>
          <template #group>
            <div class="tw-flex tw-h-full tw-items-center tw-justify-center tw-gap-4 tw-px-2">
              <select v-model="filtersModel.min_bedroom">
                <option
                  v-for="(bedroomCount, index) in minBedroomCounts"
                  :key="`bedroomCountForMin-${index}`"
                  :value="bedroomCount.value"
                >
                  {{ bedroomCount.name }}
                </option>
              </select>
              <select v-model="filtersModel.max_bedroom">
                <option
                  v-for="(bedroomCount, index) in maxBedroomCounts"
                  :key="`bedroomCountForMax-${index}`"
                  :value="bedroomCount.value"
                >
                  {{ bedroomCount.name }}
                </option>
              </select>
            </div>
          </template>
        </multiple-input-group>
        <button
          @click="openExtendedPopup()"
          class="properties-filter tw-flex tw-w-full tw-max-w-[150px] tw-items-center tw-justify-between"
        >
          <div>
            Filter
            <span v-if="advancedFilterSelectionCount > 0">({{ advancedFilterSelectionCount }})</span>
          </div>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 10L12 15L17 10H7Z" fill="var(--c-icon)" />
          </svg>
        </button>
      </div>

      <div class="tw-flex">
        <button
          @click="onSearch()"
          class="properties-searchbox-button n-primary tw-flex tw-h-full tw-w-full tw-flex-nowrap tw-items-center tw-justify-center tw-gap-4"
        >
          SEARCH
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="margin-bottom: 2px"
          >
            <path
              d="M15.0014 13.3347L10.7064 9.03974C11.5004 7.83299 11.8185 6.37454 11.5989 4.94678C11.3794 3.51901 10.6379 2.22349 9.51798 1.31104C8.39809 0.398585 6.97948 -0.0658869 5.5368 0.00754779C4.09412 0.0809825 2.73 0.6871 1.70855 1.70855C0.6871 2.73 0.0809825 4.09412 0.00754779 5.5368C-0.0658869 6.97948 0.398585 8.39809 1.31104 9.51798C2.22349 10.6379 3.51901 11.3794 4.94678 11.5989C6.37454 11.8185 7.83299 11.5004 9.03974 10.7064L13.3347 15.0014L15.0014 13.3347ZM1.66807 5.83474C1.66807 3.53724 3.53724 1.66807 5.83474 1.66807C8.13224 1.66807 10.0014 3.53724 10.0014 5.83474C10.0014 8.13224 8.13224 10.0014 5.83474 10.0014C3.53724 10.0014 1.66807 8.13224 1.66807 5.83474Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
    </div>
  </template>

  <div
    v-else-if="version === 'v6'"
    class="properties-search-box tw-flex tw-flex-col tw-gap-6 tw-bg-white tw-px-6 tw-py-8"
    style="border-radius: var(--rounded-input)"
  >
    <h4 class="search-title">{{ title ? title : 'Search' }}</h4>
    <div
      v-if="buy && rent && alternativeLayout"
      class="n-searchbox tw-col-span-3 tw-flex tw-w-full tw-gap-2 tw-border tw-p-[2px] xl:tw-col-span-1"
      style="border-radius: var(--rounded); min-width: 140px"
    >
      <button
        class="tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-whitespace-nowrap"
        :class="{
          'n-secondary active': searchType === PFilterSearchType.SALES,
          'n-secondary': searchType === PFilterSearchType.LETTINGS,
        }"
        @click="onSearchTypeChanged(PFilterSearchType.SALES)"
      >
        BUY
      </button>
      <button
        class="tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-whitespace-nowrap"
        :class="{
          'n-secondary active': searchType === PFilterSearchType.LETTINGS,
          'n-secondary': searchType === PFilterSearchType.SALES,
        }"
        @click="onSearchTypeChanged(PFilterSearchType.LETTINGS)"
      >
        RENT
      </button>
    </div>
    <div v-if="buy && rent && !alternativeLayout" class="n-searchbox tw-flex tw-w-full tw-gap-4">
      <!-- buy -->
      <button
        class="select-button"
        :class="{ active: searchType === PFilterSearchType.SALES }"
        @click="onSearchTypeChanged(PFilterSearchType.SALES)"
      >
        BUY
      </button>
      <!-- rent -->
      <button
        class="select-button"
        :class="{ active: searchType === PFilterSearchType.LETTINGS }"
        @click="onSearchTypeChanged(PFilterSearchType.LETTINGS)"
      >
        RENT
      </button>
    </div>
    <!-- search -->
    <div class="searchbox-location-selectbox">
      <locations version="v2" v-model="searchInputModel" v-model:locations="locationsModel" />
    </div>
    <library-properties-search-box-price-input v-model:filters="filtersModel" :search-type="searchType" version="v2" />

    <div class="bedroom-filter tw-flex tw-items-center tw-gap-4">
      <multiple-input-group popup-width="300px" class="tw-w-full tw-min-w-[173px]">
        <template #front-item>
          <div
            class="multiple-input-group tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-border tw-bg-white tw-py-3 tw-pl-4 tw-pr-5"
            style="border-radius: var(--rounded-input); border-color: var(--c-border)"
          >
            <div class="tw-text-nowrap">{{ minMaxBedroomLabel }}</div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10L12 15L17 10H7Z" fill="var(--c-icon)" />
            </svg>
          </div>
        </template>
        <template #group>
          <div class="tw-flex tw-gap-4 tw-px-2">
            <select v-model="filtersModel.min_bedroom">
              <option
                v-for="(bedroomCount, index) in minBedroomCounts"
                :key="`bedroomCountForMin-${index}`"
                :value="bedroomCount.value"
              >
                {{ bedroomCount.name }}
              </option>
            </select>

            <select v-model="filtersModel.max_bedroom">
              <option
                v-for="(bedroomCount, index) in maxBedroomCounts"
                :key="`bedroomCountForMax-${index}`"
                :value="bedroomCount.value"
              >
                {{ bedroomCount.name }}
              </option>
            </select>
          </div>
        </template>
      </multiple-input-group>

      <!-- filter -->
      <button
        @click="openExtendedPopup()"
        class="property-filter-btn n-quaternary tw-flex tw-w-full tw-items-center tw-justify-between"
      >
        <div>
          Filter
          <span v-if="advancedFilterSelectionCount > 0">({{ advancedFilterSelectionCount }})</span>
        </div>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 7.5H7C6.60218 7.5 6.22064 7.65804 5.93934 7.93934C5.65804 8.22064 5.5 8.60218 5.5 9V17C5.5 17.3978 5.65804 17.7794 5.93934 18.0607C6.22064 18.342 6.60218 18.5 7 18.5H15C15.3978 18.5 15.7794 18.342 16.0607 18.0607C16.342 17.7794 16.5 17.3978 16.5 17V12"
            stroke="var(--c-icon)"
            stroke-width="1.2"
            stroke-linecap="round"
          />
          <path
            d="M12.5 11.5L18.864 5.136M14.5 4.5H19.5V9.5"
            stroke="var(--c-icon)"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
    <button @click="onSearch()" class="n-primary search-button tw-h-full tw-w-full">
      <template v-if="!iconOnly">Search</template>
      <template v-if="iconOnly">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          :class="{ 'tw-ml-2': !iconOnly }"
        >
          <path
            d="M17.4995 15.8333L13.2045 11.5383C13.9985 10.3316 14.3165 8.87314 14.097 7.44537C13.8774 6.01761 13.1359 4.72208 12.016 3.80963C10.8961 2.89718 9.47752 2.43271 8.03484 2.50614C6.59216 2.57958 5.22805 3.1857 4.2066 4.20715C3.18515 5.22859 2.57903 6.59271 2.50559 8.03539C2.43216 9.47807 2.89663 10.8967 3.80908 12.0166C4.72154 13.1365 6.01706 13.878 7.44483 14.0975C8.87259 14.317 10.331 13.999 11.5378 13.205L15.8328 17.5L17.4995 15.8333ZM4.16612 8.33333C4.16612 6.03584 6.03529 4.16667 8.33279 4.16667C10.6303 4.16667 12.4995 6.03584 12.4995 8.33333C12.4995 10.6308 10.6303 12.5 8.33279 12.5C6.03529 12.5 4.16612 10.6308 4.16612 8.33333Z"
            fill="white"
          />
        </svg>
      </template>
    </button>
  </div>

  <template v-else-if="version === 'v7'">
    <h4 v-if="title" class="tw-pb-8">{{ title }}</h4>

    <div
      class="properties-search-box tw-grid tw-w-full tw-grid-cols-1 tw-justify-between tw-gap-1 max-2xl:tw-gap-6 2xl:tw-grid-cols-[13%,75%,10%]"
      :class="{ '2xl:!tw-grid-cols-[87%,12%]': !(buy && rent) }"
    >
      <div
        v-if="buy && rent && alternativeLayout"
        class="n-searchbox tw-col-span-3 tw-flex tw-w-full tw-gap-2 tw-border tw-p-[2px] xl:tw-col-span-1"
        style="border-radius: var(--rounded); min-width: 140px"
      >
        <button
          class="tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-whitespace-nowrap"
          style="padding: 0.75em 1.5em !important"
          :class="{
            'n-secondary active': searchType === PFilterSearchType.SALES,
            'n-secondary': searchType === PFilterSearchType.LETTINGS,
          }"
          @click="onSearchTypeChanged(PFilterSearchType.SALES)"
        >
          BUY
        </button>
        <button
          class="tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-whitespace-nowrap"
          style="padding: 0.75em 1.5em !important"
          :class="{
            'n-secondary active': searchType === PFilterSearchType.LETTINGS,
            'n-secondary': searchType === PFilterSearchType.SALES,
          }"
          @click="onSearchTypeChanged(PFilterSearchType.LETTINGS)"
        >
          RENT
        </button>
      </div>

      <div
        v-if="buy && rent && !alternativeLayout"
        class="n-searchbox tw-col-span-3 tw-flex tw-w-full tw-gap-2 tw-border tw-p-[2px] xl:tw-col-span-1"
        style="border-radius: var(--rounded); min-width: 140px"
      >
        <button
          class="select-button tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-whitespace-nowrap"
          :class="{ active: searchType === PFilterSearchType.SALES }"
          @click="onSearchTypeChanged(PFilterSearchType.SALES)"
        >
          BUY
        </button>
        <button
          class="select-button tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-whitespace-nowrap"
          :class="{ active: searchType === PFilterSearchType.LETTINGS }"
          @click="onSearchTypeChanged(PFilterSearchType.LETTINGS)"
        >
          RENT
        </button>
      </div>

      <div
        class="searchbox-container tw-flex tw-gap-2 tw-border"
        style="border-color: var(--c-border); border-radius: var(--rounded)"
      >
        <div class="searchbox-location-selectbox tw-w-full">
          <locations v-model="searchInputModel" v-model:locations="locationsModel" version="v2" />
        </div>
        <div style="width: 100%; max-width: 240px" class="tw-border-r">
          <library-properties-search-box-price-input
            v-model:filters="filtersModel"
            :search-type="searchType"
            version="v2"
          />
        </div>
        <multiple-input-group
          popup-width="300px"
          class="tw-h-full tw-w-full tw-max-w-[173px] tw-border-r"
          style="border-color: var(--c-border)"
        >
          <template #front-item>
            <div
              class="searchbox-bedroom tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-bg-white tw-py-5 tw-pl-4 tw-pr-5"
            >
              <div class="tw-text-nowrap">{{ minMaxBedroomLabel }}</div>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 10L12 15L17 10H7Z" fill="var(--c-icon)" />
              </svg>
            </div>
          </template>
          <template #group>
            <div class="tw-flex tw-h-full tw-items-center tw-justify-center tw-gap-4 tw-px-2">
              <select v-model="filtersModel.min_bedroom">
                <option
                  v-for="(bedroomCount, index) in minBedroomCounts"
                  :key="`bedroomCountForMin-${index}`"
                  :value="bedroomCount.value"
                >
                  {{ bedroomCount.name }}
                </option>
              </select>
              <select v-model="filtersModel.max_bedroom">
                <option
                  v-for="(bedroomCount, index) in maxBedroomCounts"
                  :key="`bedroomCountForMax-${index}`"
                  :value="bedroomCount.value"
                >
                  {{ bedroomCount.name }}
                </option>
              </select>
            </div>
          </template>
        </multiple-input-group>
        <button
          @click="openExtendedPopup()"
          class="properties-filter tw-flex tw-w-full tw-max-w-[150px] tw-items-center tw-justify-between tw-bg-white !tw-pl-4 !tw-pr-5"
          style="letter-spacing: 0 !important"
        >
          <div>
            Filter
            <span v-if="advancedFilterSelectionCount > 0">({{ advancedFilterSelectionCount }})</span>
          </div>
          <span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10L12 15L17 10H7Z" fill="var(--c-icon)" />
            </svg>
          </span>
        </button>
      </div>

      <div class="search-btn-icon tw-flex tw-h-full tw-items-center">
        <button @click="onSearch()" class="properties-searchbox-button n-primary tw-h-full tw-w-full">
          <template v-if="!iconOnly">SEARCH</template>
          <template v-if="iconOnly">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              :class="{ 'tw-ml-2': !iconOnly }"
            >
              <path
                d="M17.4995 15.8333L13.2045 11.5383C13.9985 10.3316 14.3165 8.87314 14.097 7.44537C13.8774 6.01761 13.1359 4.72208 12.016 3.80963C10.8961 2.89718 9.47752 2.43271 8.03484 2.50614C6.59216 2.57958 5.22805 3.1857 4.2066 4.20715C3.18515 5.22859 2.57903 6.59271 2.50559 8.03539C2.43216 9.47807 2.89663 10.8967 3.80908 12.0166C4.72154 13.1365 6.01706 13.878 7.44483 14.0975C8.87259 14.317 10.331 13.999 11.5378 13.205L15.8328 17.5L17.4995 15.8333ZM4.16612 8.33333C4.16612 6.03584 6.03529 4.16667 8.33279 4.16667C10.6303 4.16667 12.4995 6.03584 12.4995 8.33333C12.4995 10.6308 10.6303 12.5 8.33279 12.5C6.03529 12.5 4.16612 10.6308 4.16612 8.33333Z"
                fill="white"
              />
            </svg>
          </template>
        </button>
      </div>
    </div>
  </template>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import Locations from '~/components/common/Locations.vue';
import MultipleInputGroup from '~/components/common/MultipleInputGroup.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import CriteriaPreferencesConstants from '~/units/properties/constants/criteriaPreferences.constants';
import { type LocationComponent, PFilterSearchType, type PropertiesFilter } from '~/units/properties/types';
import type { SearchInput } from '~/units/properties/types/search';
import NcRadio from '~/components/common/inputs/NcRadio.vue';

export default defineNuxtComponent({
  name: 'LibraryPropertiesSearchBox',
  components: { NcButton, MultipleInputGroup, Locations, NcRadio },

  props: {
    filters: {
      required: true,
      type: Object as PropType<PropertiesFilter>,
    },

    searchType: {
      required: true,
      type: String as PropType<PFilterSearchType>,
    },

    locations: {
      required: true,
      type: Array as PropType<LocationComponent[]>,
    },

    searchInput: {
      required: true,
      type: Object as PropType<SearchInput>,
    },

    version: {
      required: false,
      type: String,
      default: 'v1',
    },

    buy: {
      required: false,
      type: Boolean,
      default: true,
    },

    rent: {
      required: false,
      type: Boolean,
      default: true,
    },

    title: {
      required: false,
      type: String,
      default: 'Search',
    },

    agentType: {
      required: false,
      type: String,
    },

    iconOnly: {
      required: false,
      type: Boolean,
      default: false,
    },

    alternativeLayout: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  emits: [
    'onSearch',
    'openExtendedPopup',
    'update:filters',
    'update:locations',
    'update:searchInput',
    'update:searchType',
  ],

  computed: {
    PFilterSearchType: () => {
      return PFilterSearchType;
    },

    filtersModel: {
      get() {
        return this.filters;
      },
      set(value: PropertiesFilter) {
        this.$emit('update:filters', value);
      },
    },

    locationsModel: {
      get() {
        return this.locations;
      },
      set(value: LocationComponent[]) {
        this.$emit('update:locations', value);
      },
    },

    searchTypeModel: {
      get() {
        return this.searchType;
      },
      set(value: PFilterSearchType) {
        this.$emit('update:searchType', value);
      },
    },

    searchInputModel: {
      get() {
        return this.searchInput;
      },
      set(value: SearchInput) {
        this.$emit('update:searchInput', value);
      },
    },

    minBedroomLabel() {
      if (this.filtersModel.min_bedroom) {
        const minBedroom = +this.filtersModel.min_bedroom;

        const selected = this.minBedroomCounts.find((item) => item && item.value && +item.value === minBedroom);
        if (selected) {
          return `Min ${selected.name}`;
        }
      }
      return 'Min';
    },

    maxBedroomLabel() {
      if (this.filters.max_bedroom) {
        const maxBedroom = +this.filters.max_bedroom;

        const selected = this.maxBedroomCounts.find((item) => item && item.value && +item.value === maxBedroom);
        if (selected) {
          return `Max ${selected.name}`;
        }
      }
      return 'Max';
    },

    minBedroomCounts() {
      return [{ value: null, name: 'No Min' }, ...CriteriaPreferencesConstants.bedroom];
    },

    maxBedroomCounts() {
      return [{ value: null, name: 'No Max' }, ...CriteriaPreferencesConstants.bedroom];
    },

    advancedFilterSelectionCount() {
      let count = 0;

      if (this.filtersModel.min_bathroom || this.filtersModel.max_bathroom) {
        count += 1;
      }

      if (this.filtersModel.min_reception || this.filtersModel.max_reception) {
        count += 1;
      }

      if (this.filtersModel.property_types && this.filtersModel.property_types.length > 0) {
        count += 1;
      }

      return count;
    },

    minMaxBedroomLabel() {
      const minBedroom = this.minBedroomLabel.split(' ')[1] || 'Min';
      const maxBedroom = this.maxBedroomLabel.split(' ')[1] || 'Max';
      return `${minBedroom} - ${maxBedroom} Beds`;
    },

    route() {
      return useRoute();
    },
  },

  methods: {
    openExtendedPopup() {
      this.$emit('openExtendedPopup');
    },

    onSearch() {
      this.$emit('onSearch');
    },

    onSearchTypeChanged(searchTypeFilter: PFilterSearchType) {
      if (searchTypeFilter === PFilterSearchType.SALES) {
        this.redirectTo({
          path: '/sales/property-for-sale',
        });
      } else if (searchTypeFilter === PFilterSearchType.LETTINGS) {
        this.redirectTo({
          path: '/lettings/property-to-rent',
        });
      }
    },
  },
});
</script>

<style scoped>
.locations-box-container {
  border: 1px solid var(--default-border-color);
}

.price-inputs-container {
  border: 1px solid var(--default-border-color);
}

.bedroom-inputs-container {
  border: 1px solid var(--default-border-color);
}

.filters-box-container {
  border: 1px solid var(--default-border-color);
}

@media (min-width: 1280px) {
  .locations-box-container {
    border-left: none;
    border-top: none;
    border-bottom: none;
    border-right: 1px solid var(--default-border-color);
  }

  .price-inputs-container {
    border-left: none;
    border-top: none;
    border-bottom: none;
    border-right: 1px solid var(--default-border-color);
  }

  .bedroom-inputs-container {
    border-left: none;
    border-top: none;
    border-bottom: none;
    border-right: 1px solid var(--default-border-color);
  }

  .filters-box-container {
    border: none;
  }
}
</style>
